const RoutePaths = {
    ROOT_PATH: '/',
    LOGIN_PATH: '/tts/login',
    HOME_PATH: '/tts/home',
    LOAN_PATH: '/tts/loan',
    ACCOUNT_MAINTENANCE: '/tts/accountMaintenance'
}

export default RoutePaths
